import { Component, OnInit } from '@angular/core';

import { PageNotFoundService } from '../page-not-found/page-not-found.service';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {

  constructor(public pageNotFound: PageNotFoundService) { }

  ngOnInit() {
  }

}
